import { useQuery } from "react-query";
import { collectionsApi, type Collection } from "@/lib/api/collections";

export const COLLECTIONS_QUERY_KEY = ["collections"] as const;

export function useCollections(includeInactive = true, options?: { enabled?: boolean }) {
  return useQuery<Collection[]>(
    [...COLLECTIONS_QUERY_KEY, includeInactive],
    () => collectionsApi.getAll(includeInactive),
    { staleTime: 60 * 60 * 1000, enabled: options?.enabled ?? true }
  );
}
